import '@/styles/index.styl';
import GlobalComponents from '@/components/_index';
import { createApp } from 'vue';
import App from './App.vue';
import UrlParams from './core/UrlParams';
import { setupI18n } from './core/i18n';

class Nars30Anniversary extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const options = App as any;
    const propsList: string[] = Array.isArray(options.props) ? options.props : Object.keys(options.props || {});
    const props: { [index: string]: string | boolean } = {};

    // Validate, if all props are present
    for (const prop of propsList) {
      const propValue = this.attributes.getNamedItem(prop)?.value;
      if (!propValue) {
        if (options.props[prop].required) {
          console.error(`Missing attribute ${prop}`);
          return;
        }
      } else {
        props[prop] = propValue;
      }
    }

    const app = createApp(App, props);
    
    const lang = UrlParams.getString("lang") || props["lang"];
    app.use(setupI18n(lang ? lang as string : null));

    GlobalComponents.register(app);
    
    const wrapper = document.createElement("div");
    app.mount(wrapper);

    this.appendChild(wrapper.children[0]);
  }
}

window.customElements.define("nars-30anniversary", Nars30Anniversary);
